var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose1010(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.227065 0.226994C0.519958 -0.0658991 0.994832 -0.0658991 1.28772 0.226994L5.00006 3.93933L8.71235 0.227047C9.00524 -0.0658466 9.48011 -0.0658466 9.77301 0.227047C10.0659 0.51994 10.0659 0.994814 9.77301 1.28771L6.06072 4.99999L9.77301 8.71228C10.0659 9.00517 10.0659 9.48004 9.77301 9.77294C9.48011 10.0658 9.00524 10.0658 8.71235 9.77294L5.00006 6.06065L1.28772 9.77299C0.994832 10.0659 0.519958 10.0659 0.227065 9.77299C-0.0658285 9.48009 -0.0658285 9.00522 0.227065 8.71233L3.9394 4.99999L0.227065 1.28765C-0.0658285 0.994761 -0.0658285 0.519887 0.227065 0.226994Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose1010);
export default __webpack_public_path__ + "static/media/close-10-10.34f3992b53d5a3630711ca295e0c2dd9.svg";
export { ForwardRef as ReactComponent };